import { render, staticRenderFns } from "./YoneticiTanimla.vue?vue&type=template&id=52d63467&scoped=true&"
import script from "./YoneticiTanimla.vue?vue&type=script&lang=js&"
export * from "./YoneticiTanimla.vue?vue&type=script&lang=js&"
import style0 from "./YoneticiTanimla.vue?vue&type=style&index=0&id=52d63467&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d63467",
  null
  
)

export default component.exports